module.exports = __webpack_public_path__ + "media/newstyle/images/a4-white-c1ac8a4c9377596d31c591eb6a275ad7.svg";